import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { validate } from '../../../utils';

class Field extends Component {
    static propTypes = {
        value: PropTypes.any,
        fieldDef: PropTypes.object,
        errors: PropTypes.array,
        infos: PropTypes.array,
        onValueChanged: PropTypes.func
    }

    state = {
        currentValue: this.props.value
    }

    onBlurred = e => {
        const { target } = e;
        let newValue = undefined;
        if (target.type.toLowerCase() === 'checkbox'){
            newValue = target.checked;
        } else {
            newValue = target.value;
        }

        if (typeof(newValue) == 'string' && newValue.trim().length === 0){
            newValue = null;
        }

        const changed = newValue !== this.state.currentValue;

        if (changed) {
            var state = {currentValue: newValue};

            var data = {};
            data[target.name] = newValue;
            this.props.onValueChanged(data);

            this.setState(state);
        }
    }

    getClassNames(){
        var names = [];
        if (this.props.fieldDef.isRequired)
            names.push('ac-required');

        if (this.props.errors && this.props.errors.length > 0){
            names.push('ac-error');
        } else if (this.props.infos && this.props.infos.length > 0) {
            names.push('ac-info');
        }

        return names.join(' ');
    }

    getDefaultInputType(dataType) {
        switch(dataType) {
            case "INTEGER":
            case "DECIMAL":
            case "STRING":
            case "DATE":
            case "DATETIME":
                return "TEXT";
            case "BOOLEAN":
                return "CHECKBOX"
            default:
                return "TEXT";
        }
    }

    getInputType(f) {
        switch (f.inputType || "DEFAULT") {
            case "DEFAULT":
                return this.getDefaultInputType(f.dataType);
            default:
                return f.inputType;
        }

    }

    validate(value){
        console.log('Input.validate', value);

        var fd = this.props.fieldDef;
        if (fd !== null) {
            return validate(fd, value);
        }
    }

    parseValue(value) {
        let dataType = this.props.fieldDef.dataType;
        switch(this.props.fieldDef.dataType) {
            case "INTEGER":
                return parseInt(value);
            case "DECIMAL":
                return parseFloat(value);
            case "BOOLEAN":
                return (value.toLowerCase() in ['true', 'yes', '1']);
            case "DATE":
            case "DATETIME":
                return Date.parse(value);
            default:
                return value;
        }
    }

    onChecklistChanged = e => {
        const { target } = e;

        let newArray = [...(this.state.currentValue == null ? [] : this.state.currentValue)];
        let optValue = this.parseValue(target.value);
        //debugger;
        if (target.checked) {
            newArray.push(optValue);
        }
        else
        {
            let itemIdx = newArray.indexOf(optValue);
            if (itemIdx > -1) {
                newArray.splice(itemIdx, 1);
            }
        }

        const changed = (this.state.currentValue == null ? [] : this.state.currentValue).length != newArray.length;

        if (changed) {
            console.log(this.state.currentValue, newArray);
            let state = {currentValue: newArray};

            let data = {};
            data[target.name] = newArray;
            this.props.onValueChanged(data);

            this.setState(state);
        }
    }

    renderInput(f) {
        let opts = [];
        switch(this.getInputType(f)) {
            case "TEXT":
                return <input type="text" name={f.key} id={f.key}
                              placeholder={f.valueHint}
                              defaultValue={this.props.value}
                              onBlur={this.onBlurred}
                              ref={(me) => this.input = me}/>
            case "MULTILINE":
                return <textarea name={f.key} id={f.key}
                              rows="4"
                              placeholder={f.valueHint}
                              defaultValue={this.props.value}
                              onBlur={this.onBlurred}
                              ref={(me) => this.input = me}/>
            case "SELECT":
                opts = f.inputSettings.options.map((o) => <option key={o.key} value={o.key}>{o.value}</option>)
                return <div>
                    <select name={f.key} id={f.key} onChange={this.onBlurred} defaultValue={this.props.value}>{opts}</select>
                    <span className="ac-value-hint"> {f.valueHint}</span>
                </div>
            case "CHECKBOX":
                return (<div>
                    <label htmlFor={f.key}><input type="checkbox" name={f.key} id={f.key}
                              defaultChecked={this.props.value}
                              onBlur={this.onBlurred}
                              ref={(me) => this.input = me}
                    />
                        <span className="ac-option-text" htmlFor={f.key}> {f.valueHint}</span></label>
                </div>)
            case "MULTISELECT":
                opts = f.inputSettings.options.map((o) => <label key={o.key} className="ac-input-item" htmlFor={o.key}>
                    <input type="checkbox"
                           name={f.key}
                           id={o.key}
                           value={o.key}
                           defaultChecked={this.state.currentValue instanceof Array && this.state.currentValue.indexOf(o.key) > -1}
                           onChange={this.onChecklistChanged}
                           ref={(me) => this.input = me}
                    /><span className="ac-option-text" htmlFor={o.key}> {o.value}</span>
                </label>);
                return (
                    <div>
                        <div className="ac-value-hint">{f.valueHint}</div>
                        <div className="ac-input-list">
                        {opts}
                        </div>
                    </div>
                )
        }
    }

    render() {
        var f = this.props.fieldDef;
        var errors = this.props.errors ? this.props.errors.map((e, i) => <div key={i}>{e}</div>) : '';
        var infos = this.props.infos ? this.props.infos.map((m, i) => <div key={i}>{m}</div>) : '';

        return <div key={f.key} className={this.getClassNames()}>
        <label htmlFor={f.key}>{f.label}</label>
            {this.renderInput(f)}
        {errors}
        {infos}
       </div>
    }

    focus() {
        if (this.input) {
            this.input.focus();
        }
    }
}

export default Field;